<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { HTMLImgAttributes } from 'svelte/elements';

	const {
		children,
		href,
		text,
		scaleOnHover = false,
		...rest
	}: {
		children: Snippet;
		href?: string;
		text?: string;
		scaleOnHover?: boolean;
	} & HTMLImgAttributes = $props();
</script>

<a
	{href}
	class={['group relative flex h-full items-center justify-center overflow-hidden', rest.class]}
>
	<div
		class={[
			'h-full w-full object-cover',
			{ 'transition-transform duration-300 group-hover:scale-105': scaleOnHover },
		]}
	>
		{@render children()}
	</div>
	{#if text}
		<span
			class="absolute bottom-5 left-1/2 -translate-x-1/2 touch-manipulation rounded-md bg-black/50 px-8 py-2 text-center font-semibold text-white uppercase transition duration-300 group-hover:bg-black/100"
			>{text}</span
		>
	{/if}
</a>
